"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_a_config_provider = (0, vue_1.resolveComponent)("a-config-provider");
    return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_a_config_provider, { locale: _ctx.locale }, {
        default: (0, vue_1.withCtx)(() => [
            (0, vue_1.renderSlot)(_ctx.$slots, "default")
        ]),
        _: 3
    }, 8, ["locale"]));
}
exports.render = render;
